import React from 'react'
import ForgotPassword from '../../components/ForgotPassword/UpdatePassword';

function index() {
  return (
    <>
        <ForgotPassword/>
    </>
  )
}

export default index